/*
 * @Description: 跟进管理接口模块
 * @Author: mdb
 * @Date: 2022-07-19 10:24:19
 * @LastEditTime: 2023-03-03 11:00:28
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  FbuVisitorProgramParams,
  FbuVisitorProgramListResult,
  FbuVisitorProgramEditParams
} from '@/typings/api/followUpManage'

/**
 * ************************************** 访客计划 **************************************
 */
//  获取访客计划列表数据
export function visitorProgramList(data?: FbuVisitorProgramParams) {
  return request.post<FbuVisitorProgramListResult, FbuVisitorProgramListResult>('/ofbu/api/visitPlan/page', data)
}
// 删除访客计划
export function visitorProgramDelete(id: string) {
  return request.delete<AxiosResult, AxiosResult>(`/ofbu/api/visitPlan/${id}`)
}
// 新增、编辑访客计划
export function visitorProgramCreateOrUpdate(data: FbuVisitorProgramEditParams) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/visitPlan/createOrUpdate', data)
}
// 访客计划详情
export function visitorProgramDetail(id: string) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/visitPlan/${id}`)
}

/**
 *************************************** 跟进记录列表**************************************
 */
export function fbuFollowRecordsList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/followRecords/page', data)
}
/**
 * 跟进记录详情
 */
export function followRecordsDetail(id: any) {
  return request.get<AxiosResult, AxiosResult>(`/ofbu/api/followRecords/${id}`)
}
/**
 * 跟进记录新增/编辑
 */
export function followRecordsAddOrUpdate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/followRecords/createOrUpdate', data)
}
/**
 * 跟进记录删除
 */
export function followRecordsDelete(id: any) {
  return request.delete<AxiosResult, AxiosResult>(`/ofbu/api/followRecords/${id}`)
}
/**
 * 获取跟进相关信息
 */
export function followRecordsAddByMess(params: any) {
  return request.get<AxiosResult, AxiosResult>('/ofbu/api/followRecords/getFollowInfo', { params })
}
/**
 * 获取跟进记录日期
 */
export function followRecordsDate(params?: any) {
  return request.get<AxiosResult, AxiosResult>('/ofbu/api/followRecords/getStartDate', { params })
}
/**
 * 添加评论
 */
export function followRecordsAddComment(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/followRecords/addComment', data)
}
/**
 *删除评论
 */
export function followRecordsDelComment(id: any) {
  return request.delete<AxiosResult, AxiosResult>(`/ofbu/api/followRecords/deleteComment/${id}`)
}
